import { config as commonConfig } from '../../../common/global/config';
import { MerchantsConfig } from '../../../common/types';

export const config: MerchantsConfig = {
  ...commonConfig,
  merchantsApiUrl: process.env.REACT_APP_MERCHANTS_API_URL ?? '',
  usersMaxNo: Number.parseInt(process.env.REACT_APP_USERS_MAX_NO ?? '4'),
  showAnalytics: process.env.REACT_APP_SHOW_ANALYTICS === 'true',
};
